import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, NgZone, ChangeDetectorRef, AfterViewChecked, HostListener, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { slideInAnimation } from '../../animations/route-animation';
declare var $: any;
import Swal from 'sweetalert2';

@Component({
	selector: 'app-company-navbar',
	templateUrl: './company-navbar.component.html',
	styleUrl: './company-navbar.component.scss',
	animations: [slideInAnimation]
})
export class CompanyNavbarComponent implements AfterViewChecked, OnInit {
	homeUrl = this.apiService.getHomeURL();
	user: any = null;
	loader1 = false;
	constructor(private changeRef: ChangeDetectorRef, private observer: BreakpointObserver, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) { }

	ngOnInit(): void {
		this.loader1 = true;
		this.apiService.getLoggedInUser().subscribe({
			next: (data: any) => {
				data.data.user.company = data.data.company;
				data.data.user.company_name = data.data.company_details?.com_name;
				data.data.user.usertype = data.data.type || "SC";
				this.user = data.data.user;
				if (localStorage.getItem("usertype") != this.user.usertype) {
					this.logoutUser();
				}
				this.apiService.setUserData(this.user);
				this.loader1 = false;
			}, error: (error) => {
				this.user = null;
				this.apiService.setUserData(this.user);
				this.loader1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	ngAfterViewChecked(): void {
		this.changeRef.detectChanges();
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}

	logoutUser() {
		this.apiService.logout().subscribe({
			next: () => {
				this.apiService.navigateToLogin(false);
			}, error: () => {
				this.apiService.navigateToLogin(false);
			}
		});
	}

	scrollToTop() {
		let selector = "#page-content-container-common";
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 70 + 'px'
			}, 'fast');
		} catch (error) { }
	}

	showScrollBtn = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(e: any) {
		try {
			if ($('#main-menu-header').offset().top) {
				this.showScrollBtn = true;
			} else {
				this.showScrollBtn = false;
			}
		} catch (error) { }
	}
}
